/**
 * The line every Dave deal card ends with, below a divider: deal type and
 * dates · current → deal price (% off) · a Lightning Deal's committed units ·
 * time to start. Renders nothing when the card has no deal line.
 */
import { Box, Divider, Typography } from "@mui/material";

import { getDealLine } from "./daveCardCopy";

const DaveDealLine = ({ daveData, marketplace, now, withDivider = true }) => {
  const line = getDealLine(daveData, { marketplace, now });
  if (!line) return null;
  return (
    <Box data-testid="dave-deal-line">
      {withDivider && <Divider sx={{ my: 1 }} />}
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "baseline",
          columnGap: 1,
          rowGap: 0.25,
          color: "#777",
        }}
      >
        <Typography variant="caption">{line.deal}</Typography>
        {line.currentPrice && line.dealPrice && (
          <Typography variant="caption">
            <Box component="span" sx={{ textDecoration: "line-through" }}>
              {line.currentPrice}
            </Box>{" "}
            <Box component="span" sx={{ fontWeight: 600, color: "#333" }}>
              {line.dealPrice}
            </Box>
            {line.discount && ` ${line.discount}`}
          </Typography>
        )}
        {line.units && <Typography variant="caption">{line.units}</Typography>}
        {line.when && (
          <Typography variant="caption" sx={{ fontWeight: 600, color: "#555" }}>
            {line.when}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default DaveDealLine;
